<div>
  <app-label [for]="name" [label]="label" *ngIf="showLabel"></app-label>
  <input
    (blur)="onTouched()"
    (ngModelChange)="onChange($event)"
    [(ngModel)]="value"
    [class.invalid]="showError"
    [class.success]="showSuccess"
    [id]="name"
    [name]="name"
    [step]="step"
    [disabled]="disabled"
    [type]="getFieldType()"
  />
  <span *ngIf="showError">{{error}}</span>
</div>

